import React, { useEffect, useState } from "react";
import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, defaultMdCmParam } from "@/utils/constants";
import { ISearchPage, OptionDsType } from "@/types/FmsTypes";
import { UserTypeEnum } from "@/types/FmsEnums";
import { useGlobalModel } from "@/model/globalModel";
import { convertRes2Blob } from "@/utils/exportFile";
import { IBillDetail, IBIllFields, IBillSearch, IBillSearchParam, IBillSummary } from "../BillTypes";
import { accountService } from "@/views/account/AccountService";
import { transPgToPagination } from "@/views/base/app/appModel";
import { billService } from "../BillService";
import { ITreeData } from "../../base/dict/dictModel";
import { IMdOrgDetail } from "@/views/base/org/orgService";
import { labelsType } from "@/views/cash/pay/cashPayModel";
import { IAllotAccountDetail, IAllotAccountSummary } from "@/views/account/AccountTypes";

export const useBillRechargeLogModel = createModel(function () {
    const initSearchParam: IBillSearchParam = {supplier:'0'};
    const initDataSource: IBillDetail[] = [];
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const { user: { shopCode } } = useGlobalModel();

    //查询条件
    const [searchParam, setSearchParam] = useState<IBillSearchParam>(initSearchParam);
    //列表数据源
    const [dataSource, setDataSource] = useState<any>(initDataSource);
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    const [selectedData, setSelectedData] = useState<IBIllFields>();
    //列表数据源分页参数
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    const [approvalDrawerVisible, setApprovalDrawerVisible] = useState(false);

    const [billSummaryData, setBillSummaryData] = useState<number>(0);
    const [writeoffDrawerVisible, setWriteoffDrawerVisible] = useState(false);

    const [orgDs, setOrgDs] = useState<ITreeData<IMdOrgDetail>[]>();
	const [beDs, setBeDs] = useState<OptionDsType[]>();
	const [appDs, setAppDs] = useState<OptionDsType[]>();
	const [payMethodDs, setPayMethodDs] = useState<OptionDsType[]>();
	const [payMethodLabels, setPayMethodLabels] = useState<labelsType>({});
    const [customerUserDs, setCustomerUserDs] = useState<OptionDsType[]>(); // 选中客户下的账户列表
    const [customerUserList, setCustomerUserList] = useState<IAllotAccountDetail[]>(); // 选中客户下的账户列表


    const onSearch = () => {
        loadData({ pageNum: 1 }).then()
    }
    const onReset = () => {
        resetSearchParam()
    }


    const updatePgCfg = (updateParam: TablePaginationConfig) => {
        setPgCfg({ ...pgCfg, ...updateParam })
    }
    const updateSearchParam = (updateParam: any) => {
        if (updateParam.time) {
			if (updateParam.time[0] && updateParam.time[1]) {
				// updateParam.startTime = updateParam.time[0] + ' 00:00:00'
				// updateParam.endTime = updateParam.time[1] + ' 23:59:59'
                updateParam.rechargeTimeRange={
                    startTime:updateParam.time[0] + ' 00:00:00',
                    endTime:updateParam.time[1] + ' 23:59:59'
                }
			} else {
                // updateParam.startTime = undefined
                // updateParam.endTime = undefined
                updateParam.rechargeTimeRange={
                    startTime:undefined,
                    endTime:undefined
                }
				updateParam.time = ['','']
			}
		}
        if(updateParam.supplier === "1" || updateParam.supplier === "0"){
            setSearchParam({ ...searchParam, ...updateParam, partnerCode: undefined })
            loadData({ pageNum: 1 }, { ...searchParam, ...updateParam, partnerCode: undefined  })
        } else {
        setSearchParam({ ...searchParam, ...updateParam })
        loadData({ pageNum: 1 }, { ...searchParam, ...updateParam })
    }
    }
    const resetSearchParam = () => {
        setSearchParam(initSearchParam);
        setSelectedRowKeys([]);
        loadData(initPgCfg, {})
    }
    const loadData = async (page: ISearchPage = initPgCfg, searchValue: IBillSearchParam = searchParam) => {
        const searchParams: any = {
            ...searchValue,
            shopCode,
            partnerTypeCode: searchValue.supplier === "1"?UserTypeEnum.SUPPLIER:UserTypeEnum.CUSTOMER,
            page: {
                pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
                pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
            }
        }
        let { retData: { records, ...pg } } = await accountService.rechargePage(searchParams);
        let { retData: billSummaryRetData } = await accountService.rechargeTotalAmount(searchParams);
        setPgCfg(transPgToPagination(pg));
        setBillSummaryData(billSummaryRetData)
        setDataSource(records);
    }


    //客户账单导出
    const billCustomerExport = async () => {
        const searchParams: any = {
            ...searchParam,
            partnerTypeCode: searchParam.supplier === "1"?UserTypeEnum.SUPPLIER:UserTypeEnum.CUSTOMER,
            shopCode,
            page: {
                pageSize: -1,
                pageNum: 1
            }
        }
        let result = await accountService.export(searchParams);
        convertRes2Blob(result);
    }

    const loadCustomer = async () => {
        const {retData} = await accountService.allotPage({page: {pageNum:1, pageSize:9999}})
        setCustomerUserList(retData.records)
        setCustomerUserDs(
            retData.records.map(item => (
                {
                    label: item.name ?? '',
                    value: item.code ?? '',
                    unitCode: item.unitCode ?? ''
                }
            ))
        )
    }

    return {
        /***field***/
        appDs,
		orgDs,
		beDs,
		payMethodDs,
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        selectedData,
        writeoffDrawerVisible,
        billSummaryData,
        customerUserDs,
        customerUserList,
        approvalDrawerVisible, 
        /***method***/
        setOrgDs,
        setApprovalDrawerVisible,
		setBeDs,
		setAppDs,
		setPayMethodDs,
		setPayMethodLabels,
        setDataSource,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData,
        updatePgCfg,
        setSelectedData,
        setWriteoffDrawerVisible,
        onSearch,
        onReset,
        billCustomerExport,
        loadCustomer,
        setSearchParam
    }
});
